import { render } from "./TheMyCollectionLeftColumn.vue?vue&type=template&id=2bdc21dc&scoped=true&ts=true"
import script from "./TheMyCollectionLeftColumn.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionLeftColumn.vue?vue&type=script&lang=ts"

import "./TheMyCollectionLeftColumn.vue?vue&type=style&index=0&id=2bdc21dc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdc21dc"]])

export default __exports__